<template>
  <div class="text-end mb-3">
    <button
      class="btn btn-primary"
      title="Exportar para Excel"
      @click="exportToExcel"
    >
      Exportar para Excel
    </button>
  </div>
  <div class="card">
    <div class="table-responsive">
      <table
        class="table table-sm table-bordered table-striped"
        id="tableReport"
      >
        <thead class="bg-teal text-white text-center">
          <tr>
            <th>Classificação dos centro de custos</th>
            <th>Valor Previsto</th>
            <th>Valor Reformulado</th>
          </tr>
        </thead>
        <tbody>
          <template
            v-for="(ccPai, index) in reports.centrosCustos"
            :key="index"
          >
            <tr>
              <td class="fs-lg" colspan="3">
                <strong>
                  {{ ccPai.codCCustoPai }} - {{ ccPai.nomeCCustoPai }}
                </strong>
              </td>
            </tr>
            <tr v-for="(ccFilho, index) in ccPai.ccFilhos" :key="index">
              <td class="fs-smxs">
                {{ ccFilho.codCCustoFilho }} -
                {{ ccFilho.nomeCCustoFilho }}
              </td>
              <td class="fs-smxs text-center">
                {{ moneyToCurrencyBr(ccFilho.valorProposta) }}
              </td>
              <td class="fs-smxs text-center">
                {{ moneyToCurrencyBr(ccFilho.valorReformulacao) }}
              </td>
            </tr>
            <tr class="table-primary">
              <td>
                <strong>
                  Total do Centro de Custo ({{ ccPai.codCCustoPai }})
                </strong>
              </td>
              <td class="fs-smxs text-center">
                <strong>
                  {{ moneyToCurrencyBr(ccPai.totais.valorProposta) }}
                </strong>
              </td>
              <td class="fs-smxs text-center">
                <strong>
                  {{ moneyToCurrencyBr(ccPai.totais.valorReformulacao) }}
                </strong>
              </td>
            </tr>
          </template>
          <tr class="table-success">
            <td><strong>Total Geral</strong></td>
            <td class="fs-smxs text-center">
              <strong>
                {{ moneyToCurrencyBr(reports.totais.valorProposta) }}
              </strong>
            </td>
            <td class="fs-smxs text-center">
              <strong>
                {{ moneyToCurrencyBr(reports.totais.valorReformulacao) }}
              </strong>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { moneyToCurrencyBr } from '@/utils/strings'
import '@/assets/js/jquery.table2excel'

export default {
  name: 'TotaisCentroCustoResult',

  props: {
    reports: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      moneyToCurrencyBr,
    }
  },

  methods: {
    exportToExcel() {
      window.$('#tableReport').table2excel({
        name: 'Totais Por Centro de Custo',
        filename: 'Relatorio_SGCC_Totais_Centro_Custo.xls',
      })
    },
  },
}
</script>

<style scoped>
td {
  padding: 0.3rem;
}
</style>
